import { ref } from 'vue-demi';
import { MaterialType } from '@tt4b/ttam-enums';
import { useGetVideoUrlByConfigApi } from '@tt4b/ttam-hooks';

export function useVideoPlayer(type: MaterialType) {
  const isPlayer = ref(false);
  const isVideoLoading = ref(false);
  const isNative = [MaterialType.Native, MaterialType.Affiliate].includes(type) ;
  let curItem, enterTimer;

  if (![MaterialType.Video, MaterialType.Native, MaterialType.Affiliate].includes(type)) {
    return {
      onMouseEnter: () => undefined,
      onMouseLeave: () => undefined,
    };
  }

  function getItemAttr(item, key) {
    if (!item) {
      return undefined;
    }

    return isNative ? item?.videoInfo[key] : item[key];
  }

  /** 获取视频地址 */
  async function getVideoUrl(item) {
    if (item.playUrl) {
      return item.playUrl;
    }

    if (!item.vid) {
      return '';
    }

    if (isNative) {
      return '';
    }

    return await useGetVideoUrlByConfigApi({ vid: item.vid, videoCode: item.videoCode });
  }

  /** 鼠标进入 */
  function _onMouseEnter(item) {
    curItem = item;
    isVideoLoading.value = true;

    function startPlay() {
      if (getItemAttr(curItem, 'vid') !== getItemAttr(item, 'vid')) {
        return;
      }
      isPlayer.value = true;
      setTimeout(() => (isVideoLoading.value = false), 1000);
    }

    if (item.playUrl) {
      startPlay();

      return;
    }

    getVideoUrl(isNative ? item.videoInfo : item).then(url => {
      item.playUrl = url;
      startPlay();
    });
  }

  /** 鼠标离开 */
  function _onMouseLeave(item) {
    curItem = undefined;
    isPlayer.value = false;
    isVideoLoading.value = false;
  }

  const onMouseEnter = item => {
    enterTimer = setTimeout(() => _onMouseEnter(item), 500);
  };
  const onMouseLeave = item => {
    if (enterTimer) {
      clearTimeout(enterTimer);
    }
    _onMouseLeave(item);
  };

  return {
    isPlayer,
    isVideoLoading,
    onMouseEnter,
    onMouseLeave,
  };
}
